export default __webpack_public_path__ + "static/media/restore.fe0f5e7d.svg";